import { Record } from "immutable";

import createFromJS from "../../createFromJS";

export const SyncUpdateTagRecord = Record({
  documentId: null,
  label: null,
  action: null
});

createFromJS.registerCallback("SyncUpdateTagRecord", createFromJS.createPrimitiveCallback(SyncUpdateTagRecord));
